export default class EventListener {
  constructor() {
    this.listeners = {};
  }

  trigger(event, payload) {
    if (Array.isArray(this.listeners[event]) === false) {
      return;
    }

    setTimeout(() => {
      this.listeners[event].forEach(callback => callback(payload));
    }, 1000);
  }

  on(event, callback) {
    if (Array.isArray(this.listeners[event]) === false) {
      this.listeners[event] = [];
    }

    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (Array.isArray(this.listeners[event]) === false) {
      return;
    }

    const index = this.listeners[event].indexOf(callback);

    if (index === -1) {
      return;
    }

    this.listeners[event].splice(index, 1);
  }
}
